import React, { useEffect } from 'react';
import Home from './Home';
export default function Homepage() {
  useEffect(() => {
    //@ts-ignore
    window.dataLayer.push({ pageCategory: 'home-page-view' });
  }, []);

  return <Home />;
}
